export default __webpack_public_path__ + "static/media/geometry-artwork-3.0aae6694.webp";